(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mm-motion-hero"] && !Shopify.designMode) return;
  try {
    const motionHeroes = new Map();
function mountMotionHeroes(scope) {
  const sections = scope.matches?.('[data-mm-motion-hero]') ? [scope] : scope.querySelectorAll('[data-mm-motion-hero]');
  sections.forEach(hero => {
    if (motionHeroes.has(hero)) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    let visible = false;
    let frame = 0;
    let pointerX = 0;
    let pointerY = 0;
    const draw = () => {
      frame = 0;
      if (!hero.isConnected || reducedMotion.matches) return;
      const rect = hero.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, -rect.top / Math.max(1, rect.height * .82)));
      hero.style.setProperty('--mm-scroll', progress.toFixed(4));
      hero.style.setProperty('--mm-pointer-x', pointerX.toFixed(3));
      hero.style.setProperty('--mm-pointer-y', pointerY.toFixed(3));
    };
    const schedule = () => { if (visible && !reducedMotion.matches && !frame) frame = requestAnimationFrame(draw); };
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) schedule();
    });
    const move = event => {
      if (!finePointer.matches || reducedMotion.matches) return;
      const rect = hero.getBoundingClientRect();
      pointerX = (event.clientX - rect.left) / rect.width * 2 - 1;
      pointerY = (event.clientY - rect.top) / rect.height * 2 - 1;
      schedule();
    };
    const leave = () => { pointerX = 0; pointerY = 0; schedule(); };
    const resetMotion = () => {
      if (reducedMotion.matches) {
        cancelAnimationFrame(frame); frame = 0;
        hero.style.removeProperty('--mm-scroll');
        hero.style.removeProperty('--mm-pointer-x');
        hero.style.removeProperty('--mm-pointer-y');
      } else schedule();
    };
    observer.observe(hero);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    hero.addEventListener('pointermove', move, { passive: true });
    hero.addEventListener('pointerleave', leave);
    reducedMotion.addEventListener('change', resetMotion);
    motionHeroes.set(hero, () => {
      observer.disconnect(); cancelAnimationFrame(frame);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      hero.removeEventListener('pointermove', move);
      hero.removeEventListener('pointerleave', leave);
      reducedMotion.removeEventListener('change', resetMotion);
      motionHeroes.delete(hero);
    });
  });
}
mountMotionHeroes(document);
document.addEventListener('shopify:section:load', event => mountMotionHeroes(event.target));
document.addEventListener('shopify:section:unload', event => {
  motionHeroes.forEach((cleanup, hero) => { if (event.target.contains(hero)) cleanup(); });
});
  } catch(e) { console.error(e); }
})();

})();
